import React from 'react';
import { compose, withState, withProps } from 'recompose';
import { callOnMount } from './patterns';
import theme, { Size } from '../lib/theme';

const { matchMedia: matchMediaValues } = theme;

interface ResponsiveRenderProps {
  match: Size;
  up: boolean;
  matches?: boolean;
  children: React.ReactNode;
}

interface MatchCache {
  [key: string]: MediaQueryList;
}

const ResponsiveRender = ({ matches, children }: ResponsiveRenderProps) => (
  <>{matches && children}</>
);

const matchCache: MatchCache = {};

export const matchMedia = (match: Size): MediaQueryList => {
  const mediaQuery =
    matchCache[match] || window.matchMedia(matchMediaValues[match]);

  matchCache[match] = mediaQuery;

  return mediaQuery;
};

export default compose(
  withState('matches', 'setMatches', false),
  withProps(({ match, up, setMatches }) => ({
    onMount() {
      if (typeof window.matchMedia === 'undefined') {
        return;
      }

      const mediaQuery = matchMedia(match);

      if (!mediaQuery) return;

      setMatches(up ? mediaQuery.matches : !mediaQuery.matches);
      mediaQuery.addListener(({ matches }) =>
        setMatches(up ? matches : !matches)
      );
    },
  })),
  callOnMount('onMount')
)(ResponsiveRender);
